var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_1779)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37257 24 0 18.6274 0 12C0 5.37257 5.37257 0 12 0C18.6274 0 24 5.37257 24 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0H12.8571V12H0C0 5.37257 5.37257 0 12 0Z",
    fill: "#0061BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40385 4.17103L6.90785 5.19189L8.03413 5.3556L7.21899 6.15017L7.41185 7.27303L6.40385 6.74246L5.39585 7.27303L5.58871 6.15017L4.77271 5.3556L5.89985 5.19189L6.40385 4.17103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68351 7.46863L10.1875 8.48949L11.3147 8.6532L10.4987 9.44863L10.6915 10.5706L9.68351 10.0401L8.67551 10.5706L8.86837 9.44863L8.05322 8.6532L9.17951 8.48949L9.68351 7.46863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68351 1.30166L10.1875 2.32251L11.3147 2.48623L10.4987 3.28166L10.6915 4.40366L9.68351 3.87309L8.67551 4.40366L8.86837 3.28166L8.05322 2.48623L9.17951 2.32251L9.68351 1.30166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51652 7.46863L4.02052 8.48949L5.1468 8.6532L4.33166 9.44863L4.52452 10.5706L3.51652 10.0401L2.50852 10.5706L2.70137 9.44863L1.88623 8.6532L3.01252 8.48949L3.51652 7.46863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4143 2.57143H12.8572V0.0342865C15.3172 0.205715 17.58 1.12286 19.4143 2.57143Z",
    fill: "#EB0038"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0003 12H12.8574V9.42857H23.726C23.906 10.26 24.0003 11.1171 24.0003 12Z",
    fill: "#EB0038"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0317 7.28571H12.8574V4.71428H21.5317C22.1317 5.50286 22.6374 6.36 23.0317 7.28571Z",
    fill: "#EB0038"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7261 14.5714C23.5289 15.4714 23.2289 16.3286 22.8432 17.1429H1.15752C0.771801 16.3286 0.471801 15.4714 0.274658 14.5714H23.7261Z",
    fill: "#EB0038"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5316 19.2857C20.7773 20.28 19.8687 21.1457 18.8402 21.8571H5.16018C4.13161 21.1457 3.22304 20.28 2.46875 19.2857H21.5316Z",
    fill: "#EB0038"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_1779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.fa25aeb26479b8d5955c0a3cac929951.svg";
export { ForwardRef as ReactComponent };